import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useRef } from "react";
import { TextField } from "@mui/material";

const TextArea: FC<Props> = ({
  onChange,
  value,
  focus = false,
  minRows = 1,
  size,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const resizeTextArea = () => {
    if (!textAreaRef?.current) return;

    const position = textAreaRef.current.getBoundingClientRect();

    if (position.height > 200) {
      return;
    }

    textAreaRef.current.style.height = "auto";

    textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px";
  };

  useEffect(resizeTextArea, [value]);

  useEffect(() => {
    if (!textAreaRef?.current) return;
    textAreaRef.current.style.height = `52px`;
    textAreaRef.current.style.minHeight = `52px`;
  }, [textAreaRef]);

  const handleChoose = () => {
    //@ts-ignore
    textAreaRef?.current?.focus();
  };

  useEffect(() => {
    if (!textAreaRef?.current || !focus) return;
    handleChoose();
  }, [textAreaRef]);

  return (
    <div className={styles.inputWrapper}>
      <TextField
        InputProps={{
          style: {
            height: size,
          },
        }}
        sx={{
          "&::textarea": {
            height: "500px !important",
          },
          "&:hover:not(.Mui-focused)": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5d49c7",
            },
          },
        }}
        multiline
        value={value}
        // label={label}
        hiddenLabel
        InputLabelProps={{ shrink: true }}
        minRows={minRows}
        maxRows={minRows}
        onChange={(e) => onChange(e.target.value)}
        variant="filled"
        size="medium"
      />
    </div>
  );
};

export default TextArea;
